import { cva } from "class-variance-authority";

export const alertPopupStyles = cva(
    "border shadow-xl rounded-lg p-6 min-w-[320px] max-w-[520px]",
    {
        variants: {
            variant: {
                success: "border-green-200 bg-green-50",
                warning: "border-yellow-200 bg-yellow-50",
                error: "border-red-200 bg-red-50",
                "delete-confirm": "border-orange-200 bg-orange-50",
                confirm: "border-blue-200 bg-blue-50",
            },
        },
        defaultVariants: {
            variant: "error",
        },
    },
);

export const alertTitleStyles = cva("text-lg font-semibold", {
    variants: {
        variant: {
            success: "text-green-700",
            warning: "text-yellow-700",
            error: "text-red-700",
            "delete-confirm": "text-orange-700",
            confirm: "text-blue-700",
        },
    },
    defaultVariants: {
        variant: "error",
    },
});

export const alertIconStyles = cva("h-6 w-6", {
    variants: {
        variant: {
            success: "text-green-500",
            warning: "text-yellow-500",
            error: "text-red-500",
            "delete-confirm": "text-orange-500",
            confirm: "text-blue-500",
        },
    },
    defaultVariants: {
        variant: "error",
    },
});

export const alertBodyStyles = cva("text-sm mb-6");
export const alertCloseButtonStyles = cva(
    "p-1 rounded hover:bg-gray-200 hover:scale-105 transition text-gray-600",
);
export const alertFooterStyles = cva("flex justify-end gap-2");
export const alertConfirmButtonStyles = cva("min-w-[80px]", {
    variants: {
        variant: {
            "delete-confirm": "bg-orange-600 hover:bg-orange-700 text-white",
            confirm: "bg-blue-600 hover:bg-blue-700 text-white",
        },
    },
});
export const alertCancelButtonStyles = cva("min-w-[80px]");

